import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, input } from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
} from '@angular/router';
import { filter } from 'rxjs';
import { StoreIdService } from '../../core/services/store-id.service';
import { ModalService } from '../../core/services/modal.service';

@Component({
  selector: 'cwo-header-navigational-button',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './header-navigational-button.component.html',
  styleUrl: './header-navigational-button.component.scss',
})
export class HeaderNavigationalButtonComponent implements OnInit {
  label = input.required<string>();
  target = input<string[]>();
  modalService = inject(ModalService);
  link = input<string>('');

  currentSection: string = '';
  storeId = inject(StoreIdService).storeId;

  private router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const segments = this.router.url.split('/');
        if(this.storeId !== 'ordering') {
          if (segments.length > 2) {
            this.currentSection = segments[segments.length -1];
          }
        } else {
          if (segments.length > 1) {
            this.currentSection = segments[segments.length -1];
          }
        }
      });
  }

  ngOnInit(): void {
    const segments = this.router.url.split('/');
    if(this.storeId !== 'ordering') {
      if (segments.length > 2) {
        this.currentSection = segments[segments.length -1];
      }
    } else {
      if (segments.length > 1) {
        this.currentSection = segments[segments.length -1];
      }
    }
    
  }

  isActive(): boolean {
    if(this.target()) {
      return this.currentSection.includes(this.target()![(this.target()?.length ?? 0) - 1]);
    }
    return false;
  }
}
